module.exports = __webpack_public_path__ + "img/icon0.c2cbbc66.png";